import { render, staticRenderFns } from "./ImportCurrencies.vue?vue&type=template&id=13b121fa&"
import script from "./ImportCurrencies.vue?vue&type=script&lang=js&"
export * from "./ImportCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports